import {convertCoordinates} from '@/api/util-coordinates';

class POIInfo {
  constructor({
    id,
    nombre,
    coordenadas: [cx, cy],
  }) {
    return {
      id,
      name: nombre,
      coordinates: convertCoordinates(cx, cy),
    };
  }
}

class Sequence {
  // #region Props

  // #endregion
  constructor({
    secuencia,
    tiempo,
    distance,
    carretera,
    tipoCarretera,
    categoria,
    peaje,
    informacion,
    poblacion,
    sitiosInteresNombre: pois,
  }) {
    const [cx, cy] = poblacion;

    return {
      seq: secuencia,
      time: tiempo,
      distance,
      routeTime: 0, // To modify after
      routeDistance: 0, // To modify after
      road: carretera,
      roadType: peaje ? tipoCarretera + '-peaje' : tipoCarretera,
      roadTypeCategory: categoria,
      information: informacion,
      townCoordinates: convertCoordinates(cx, cy),
      poiList: pois.map((poi) => new POIInfo(poi)),
    };
  }
}

class RouteDetailsApiResponseModel {
  // #region Props

  // #endregion
  constructor(data) {
    return new Sequence(data);
  }
}

export default RouteDetailsApiResponseModel;
